import {AuthMode, AuthModePersistenceInput, AuthModeResetInput, AuthModeResolutionInput} from './authTypes';

export const ENTRA_ID_PARAM = 'entra-id';
export const ENTRA_ID_STORAGE_KEY = 'auth-mode-entra-id';
const ENTRA_ID_TRUTHY_VALUES = new Set(['true', '1', 'yes']);

export function resolveAuthMode({storage, searchParams, isEntraIdForced}: AuthModeResolutionInput): AuthMode {
    if (storage.getItem(ENTRA_ID_STORAGE_KEY) === 'true') {
        return 'entra-id';
    }

    const modeRequestedInUrl = ENTRA_ID_TRUTHY_VALUES.has(
        searchParams.get(ENTRA_ID_PARAM)?.toLowerCase() ?? ''
    );

    return modeRequestedInUrl || isEntraIdForced ? 'entra-id' : 'adfs';
}

export function persistAuthMode(mode: AuthMode, {storage, url, history}: AuthModePersistenceInput): void {
    if (mode !== 'entra-id') {
        return;
    }

    storage.setItem(ENTRA_ID_STORAGE_KEY, 'true');
    url.searchParams.delete(ENTRA_ID_PARAM);
    history.replaceState({}, '', url.toString());
}

export function clearEntraIdAuthMode({storage, url, history}: AuthModeResetInput): void {
    storage.removeItem(ENTRA_ID_STORAGE_KEY);
    url.searchParams.delete(ENTRA_ID_PARAM);
    history.replaceState({}, '', url.toString());
}

